const groupPrefix = createApiRoute(ApiModule.ORDER, ApiAuthorization.EMPLOYEE, ApiDataModel.GADGETS)

export const apiGadgetsProductVariants = {
	manageGadgetsProductVariants: async (
		productId: number,
		payload: IGadgetsProductVariantUpdatePayload,
	): Promise<IGadgetsProductVariantModel[]> => {
		const { data } = await apiCommon<IGadgetsProductVariant[]>(`${groupPrefix}/${productId}/variants`, {
			method: 'POST',
			body: payload,
		})

		return data.map(GadgetsProductVariant)
	},
}
